// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toastMessage } from "../utils/toastMessage";
// import { decryptData } from "../utils/dataCipher";
// // import { decryptData } from "../utils/dataCipher";

// // this code is created an instance with base url
// export const instance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_URL}`,
// });

// // get token
// export const getToken = () => {
//   const logic_chat_token = localStorage.getItem("logic_chat_token");

//   return logic_chat_token ? logic_chat_token : null;
// };

// // Set Token
// export const setToken = (token) => {
//   return token ? localStorage.setItem("logic_chat_token", token) : null;
// };

// // Get Data From Local Storage
// export const getAuthInfo = () => {
//   try {
//     const encryptedAuthInfo = localStorage.getItem("authInfo");
//     if (!encryptedAuthInfo) return null;

//     const decryptedAuthInfo = decryptData(encryptedAuthInfo);
//     return decryptedAuthInfo ? JSON.parse(decryptedAuthInfo) : null;
//   } catch (error) {
//     console.error("Error retrieving auth info:", error);
//     return null;
//   }
// };

// export const setJwtToken = () => {
//   const token = getToken();
//   if (!token) {
//     console.error("Token is missing or invalid");
//     return {};
//   }

//   return {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   };
// };

// export const setMultiPartHeader = () => {
//   const token = getToken();
//   return {
//     headers: {
//       authorization: `Bearer ${token}`,
//       // Accept: "application/json",
//       // "Content-Type": "multipart/form-data",
//     },
//   };
// };

// // this interceptors checks user's token is valid or not
// export const AxiosInterceptor = ({ children }) => {
//   const [isSet, setIsSet] = useState(false);
//   const navigate = useNavigate();

//   const removeToken = () => {
//     localStorage.removeItem("jaipuria_token");
//   };

//   useEffect(() => {
//     const resInterceptor = (response) => {
//       if (response?.data?.code === 401) {
//         removeToken();
//         navigate("/");
//       }
//       return response;
//     };

//     const errInterceptor = (error) => {
//       console.log("Error in axios", error);
//       if (!error?.response?.data?.success && error?.response?.data?.message) {
//         // window.open(error?.response?.data?.data);
//         toastMessage(error?.response?.data?.message, "error", "unauthorized");
//       }
//       // Handle network error
//       if (error?.code === "ERR_NETWORK") {
//         return toastMessage(error?.code, "error", "networkError");
//       }

//       // Destructure and decrypt error response data safely
//       const data = error?.response?.data;
//       if (!data) {
//         return Promise.reject(error);
//       }

//       const decryptedData = data?.responseData;
//       const { responseData } = decryptedData || {};
//       const { statusCode, message } = responseData || {};
//       const msg = message?.msg || {};

//       // console.log(msg, "Message");
//       // console.log('statusCode', statusCode)
//       // console.log('responseData', responseData)

//       switch (statusCode) {
//         case 401:
//           removeToken();
//           navigate("/");
//           toastMessage(msg.ACCESS_DENIED || "Access Denied", "error", "forbidden");
//           break;

//         case 400:
//           toastMessage(msg, "error", "badRequest");
//           break;

//         case 403:
//           removeToken();
//           // Optional: Uncomment if navigation is needed
//           // navigate("/");
//           toastMessage("Forbidden access", "error", "forbidden");
//           break;

//         default:
//           if (data?.statusCode !== 200) {
//             toastMessage(msg || "An error occurred", "error", "errorMessage");
//           }
//       }

//       return Promise.reject(error);
//     };

//     const interceptor = instance.interceptors.response.use(
//       resInterceptor,
//       errInterceptor
//     );
//     setIsSet(true);

//     return () => instance.interceptors.response.eject(interceptor);
//   }, []);

//   return isSet && children;
// };

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toastMessage } from "../utils/toastMessage";
import { decryptData } from "../utils/dataCipher";
import { decryptApiData, encryptApiData, queryStringToJSON } from "../utils/encryption";

// Create an Axios instance with base URL
export const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Retrieve token from localStorage
export const getToken = () => localStorage.getItem("logic_chat_token") || null;

// Store token in localStorage
export const setToken = (token) => {
  if (token) localStorage.setItem("logic_chat_token", token);
};

// Retrieve and decrypt auth info from localStorage
export const getAuthInfo = () => {
  try {
    const encryptedAuthInfo = localStorage.getItem("authInfo");
    if (!encryptedAuthInfo) return null;
    const decryptedAuthInfo = decryptData(encryptedAuthInfo);
    return decryptedAuthInfo ? JSON.parse(decryptedAuthInfo) : null;
  } catch (error) {
    console.error("Error retrieving auth info:", error);
    return null;
  }
};

// Set Authorization header
export const setJwtToken = () => {
  const token = getToken();
  if (!token) {
    console.error("Token is missing or invalid");
    return {};
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

// Set headers for multipart requests
export const setMultiPartHeader = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    },
  };
};

// Axios interceptor for handling responses and errors
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  const removeToken = () => {
    localStorage.removeItem("logic_chat_token");
  };

  useEffect(() => {
    const resInterceptor = (response) => {
      const finalResponse = decryptApiData(response.data) || {};
      // console.log('resInterceptor', finalResponse)
      if (finalResponse.code === 401) {
        removeToken();
        navigate("/");
      }

      // return finalResponse;
      return { ...response, data: finalResponse };
    };
    const errInterceptor = (error) => {
      // console.log('errInterceptor', error)
      const errorRes = decryptApiData(error?.response?.data)
      console.log('errorRes', errorRes)
      if (error.status == 403 || error.status == 401) {
        removeToken()
        navigate("/");
      }
      // return errorRes || error;
      return { ...error, data: errorRes };
    };

    // const errInterceptor = (error) => {
    //   console.log("Error in axios", error);
    //   const errorRes = decryptApiData(error?.response?.data)
    //   console.log('errorRes', errorRes)
    //   // Handle network error
    //   if (errorRes.code === "ERR_NETWORK") {
    //     toastMessage("Network Error", "error", "networkError");
    //     return Promise.reject(error);
    //   }

    //   const status = errorRes?.response?.status;
    //   const message = errorRes?.response?.data?.message || "";

    //   // Check if it's a 401 Unauthorized error && message.toLowerCase() === "unauthorized"
    //   if (status === 401) {
    //     removeToken();
    //     navigate("/");
    //     // toastMessage("Session expired. Please login again.", "error", "unauthorized");
    //     toastMessage(message, 'error', "401")
    //     return Promise.reject(error);
    //   }
    //   else if (errorRes?.status === 401) {
    //     removeToken();
    //     navigate("/");
    //     toastMessage("Invalid token. Please login again.", "error", "unauthorized");
    //     return Promise.reject(error);
    //   }


    //   switch (status) {
    //     // case 400:
    //     //   toastMessage("Bad Request", "error", "badRequest");
    //     //   break;
    //     case 403:
    //       toastMessage("Forbidden access", "error", "forbidden");
    //       break;
    //     default:
    //       toastMessage(message || "An error occurred", "error", "errorMessage");
    //   }

    //   return Promise.reject(error);
    // };


    instance.interceptors.request.use(function (config) {
      config.transformRequest = [
        function (data = {}, headers) {
          let localData = data;
          if (["get", "delete"].includes(config.method)) {
            const params = config.url?.split("?")[1];
            localData = {
              reqData: encryptApiData({
                ...queryStringToJSON(params),
                token: getToken(),
              }),
            };
            config.params = localData;
            config.url = config.url?.split("?")[0];
            // console.log('localData', localData)
            return null;
          }

          if (["post", "put", "patch"].includes(config.method)) {
            if (headers["Content-Type"] === "multipart/form-data") {
              const formEntries = [...localData.entries()];
              const formData = new FormData();
              let textObj = {};
              formEntries.forEach(([key, value]) => {
                if (typeof value === "object") {
                  formData.append(key, value);
                } else {
                  textObj[key] = value;
                }
              });
              formData.append(
                "reqData",
                encryptApiData({
                  ...textObj,
                  // token: getToken() || textObj?.token,
                })
              );
              return formData;
            } else {
              localData = {
                reqData: encryptApiData({
                  ...data,
                  // token: getToken() || data?.token,
                }),
              };
            }
          }
          // console.log('localData ---- data', { localData, data })
          return JSON.stringify(localData);
        },
      ];

      return config;
    });

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
  }, []);

  return isSet && children;
};
